// Vendor libraries
import { CommonModule } from '@angular/common';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import * as i0 from "@angular/core";
export class SaveAsWatchlistButtonModule {
}
SaveAsWatchlistButtonModule.ɵfac = function SaveAsWatchlistButtonModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SaveAsWatchlistButtonModule)(); };
SaveAsWatchlistButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SaveAsWatchlistButtonModule });
SaveAsWatchlistButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ConfirmModalModule] });
